import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <FeaturesSection />
        <RankingSection />
        <CommentsSection />
        <IndexSection />
        <ContactSection />
        <TopicsSection />
        <CarouselSection />
        <FAQSection />
        <AboutSection />
        <MediaSection />
        <AppSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}